var map = {
	"./Details": 7,
	"./Details.js": 7,
	"./HelperComponents": 2,
	"./HelperComponents.js": 2,
	"./Projects2020etc": 28,
	"./Projects2020etc.js": 28,
	"./Projects2021": 34,
	"./Projects2021.js": 34,
	"./Projects2022": 26,
	"./Projects2022.js": 26,
	"./Projects2023": 27,
	"./Projects2023.js": 27,
	"./Projects2024": 29,
	"./Projects2024.js": 29,
	"./Projects2025": 39,
	"./Projects2025.js": 39,
	"./dataObjects": 3,
	"./dataObjects.js": 3,
	"./files/SansTimesSans@16R.ttf": 38,
	"./files/SansTimesSans@24R.ttf": 152,
	"./files/SansTimesSans@32R.ttf": 153,
	"./files/arblockbot-poster.pdf": 105,
	"./files/chi2023-slides.pdf": 79,
	"./files/chi23-584-f.pdf": 78,
	"./files/cscw2023-slides.pdf": 73,
	"./files/cv.pdf": 43,
	"./files/dis2023-slides.pdf": 76,
	"./files/dis23-f.pdf": 75,
	"./files/facct22-cfactuals.pdf": 90,
	"./files/facct22-slides.pdf": 91,
	"./files/incontext-slides.pdf": 87,
	"./files/iui2023-slides.pdf": 81,
	"./files/iui23-33-f.pdf": 80,
	"./files/kjfeng-incontext-chi22.pdf": 86,
	"./files/mp2_case_law_poster.pdf": 42,
	"./files/pton-thesis-slides.pdf": 101,
	"./files/pton-thesis.pdf": 100,
	"./files/shaped-word-clouds.pdf": 84,
	"./files/shaped-wordclouds-poster.pdf": 85,
	"./files/soups-whatsapp-slides.pdf": 97,
	"./files/soups22-whatsapp.pdf": 96,
	"./files/teachable-feeds-slides.pdf": 55,
	"./img/adoculos-cover.png": 154,
	"./img/ai-legal-advice-cover.png": 53,
	"./img/ai-ux-comm-cover.png": 155,
	"./img/album-0.jpg": 108,
	"./img/album-1.jpg": 109,
	"./img/album-2.jpg": 110,
	"./img/album-3.jpg": 111,
	"./img/album-4.jpg": 112,
	"./img/arbb-cover.png": 156,
	"./img/as-1.png": 157,
	"./img/as-2.png": 158,
	"./img/as-3.png": 159,
	"./img/as-4.png": 160,
	"./img/as-5.png": 161,
	"./img/as-cover.png": 162,
	"./img/canvil-cover.png": 51,
	"./img/case-repos-cover.png": 56,
	"./img/cf-cover.png": 163,
	"./img/cocoa-cover.png": 50,
	"./img/construction.gif": 164,
	"./img/incontext-cover.png": 165,
	"./img/inter-cover.png": 166,
	"./img/materialize-0.jpg": 116,
	"./img/materialize-1.jpg": 117,
	"./img/materialize-10.jpg": 126,
	"./img/materialize-2.jpg": 118,
	"./img/materialize-3.jpg": 119,
	"./img/materialize-4.jpg": 120,
	"./img/materialize-5.jpg": 121,
	"./img/materialize-6.jpg": 122,
	"./img/materialize-7.jpg": 123,
	"./img/materialize-8.jpg": 124,
	"./img/materialize-9.jpg": 125,
	"./img/me.png": 127,
	"./img/people/alice.png": 82,
	"./img/people/andy.png": 72,
	"./img/people/anjali.png": 104,
	"./img/people/anna.png": 88,
	"./img/people/anne.png": 103,
	"./img/people/arunesh.png": 98,
	"./img/people/arvind.png": 99,
	"./img/people/asb.png": 69,
	"./img/people/axz.png": 22,
	"./img/people/chirag.png": 89,
	"./img/people/cqz.png": 37,
	"./img/people/dan.png": 62,
	"./img/people/daniel.png": 102,
	"./img/people/dwmc.png": 32,
	"./img/people/inyoung.png": 36,
	"./img/people/jenn.png": 66,
	"./img/people/johanna.png": 83,
	"./img/people/jonathan.png": 61,
	"./img/people/joseph.png": 63,
	"./img/people/kevin-song.png": 92,
	"./img/people/king.png": 44,
	"./img/people/kjfeng.png": 13,
	"./img/people/kpu.png": 57,
	"./img/people/lawrence.png": 68,
	"./img/people/marshini.png": 95,
	"./img/people/matt.png": 58,
	"./img/people/max.png": 74,
	"./img/people/mirror.png": 93,
	"./img/people/nick.png": 70,
	"./img/people/null.png": 106,
	"./img/people/oishee.png": 94,
	"./img/people/pao.png": 60,
	"./img/people/pia.png": 71,
	"./img/people/tal.png": 59,
	"./img/people/tony.png": 77,
	"./img/people/vera.png": 64,
	"./img/people/xander.png": 67,
	"./img/people/ziang.png": 65,
	"./img/plaque-0.jpg": 113,
	"./img/plaque-1.jpg": 114,
	"./img/plaque-2.jpg": 115,
	"./img/policy-prototyping-cover.png": 52,
	"./img/provenance-cover.png": 167,
	"./img/rehack-0.png": 168,
	"./img/rehack-1.png": 169,
	"./img/rehack-10.png": 170,
	"./img/rehack-12.png": 171,
	"./img/rehack-13.png": 172,
	"./img/rehack-14.png": 173,
	"./img/rehack-15.png": 174,
	"./img/rehack-16.png": 175,
	"./img/rehack-17.jpg": 176,
	"./img/rehack-18.png": 177,
	"./img/rehack-19.jpg": 178,
	"./img/rehack-2.png": 179,
	"./img/rehack-20.jpg": 180,
	"./img/rehack-21.jpg": 181,
	"./img/rehack-22.jpg": 182,
	"./img/rehack-3.png": 183,
	"./img/rehack-4.png": 184,
	"./img/rehack-5.png": 185,
	"./img/rehack-6.png": 186,
	"./img/rehack-7.png": 187,
	"./img/rehack-8.png": 188,
	"./img/rehack-cover.png": 189,
	"./img/rehack-team.jpg": 190,
	"./img/sts-1.png": 191,
	"./img/sts-2.png": 192,
	"./img/sts-3.png": 193,
	"./img/sts-4.png": 194,
	"./img/sts-5.png": 195,
	"./img/sts-6.png": 196,
	"./img/sts-7.png": 197,
	"./img/sts-cover.png": 198,
	"./img/teachable-feeds-cover.png": 54,
	"./img/ux-collab-cover.png": 199,
	"./img/ux-iml-cover.png": 200,
	"./img/whatsapp-cover.png": 201,
	"./img/wordclouds-teaser.png": 202
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 151;